import { Component, Input } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { SportsService } from '../../../../../services/sport.service';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-info',
  standalone: true,
  imports: [CommonModule, NzGridModule, TranslateModule],
  templateUrl: './dashboard-info.component.html',
  styleUrl: './dashboard-info.component.scss',
})
export class DashboardInfoComponent {
  @Input() set infoH2H(infoH2H: { info: Array<any>; name: any }) {
    this.h2hStatics = infoH2H;
  }

  h2hStatics: { info: Array<any>; name: any } = { info: [], name: '' };

  public moreMatches: boolean = true;

  urlIMG = environment.urlIMG;

  constructor(
    private readonly sportsServices: SportsService,
    private route: Router
  ) {}

  ngOnInit(): void {}

  matchSelected(match: any) {
    this.route.navigate([
      `/partido/${this.sportsServices.getSelectedSport()}/${match.idMatch}/${
        match.dataHome.id
      }/${match.dataAway.id}/${match.idCompetition}/${match.matchDateISO}`,
    ]);
  }
}
